module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAMCAYAAAB1Lg0yAAAAAXNSR0IArs4c6QAAAJ1JREFUOE+9lDEKAkEMRd8/sKh4BllB9CBiI4jNnkQRRL2CothEZpmAqGw1k1Sp8pJHElE4zGwLjCQd+0qrMBczM+ABzIGZpJT/RC2wg07AWNLmm1wb7LwdMPzUr6ymtPF/9Z5Zf5P0R4K9mXO3fIETO/gADCLBd2AKLCS9opZrDUwkXXzs2uB9p1Vqo87plrUuk9aoB7LKWq99N/oGnylInUCnF4oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tiaozhuan.png
// module id = CusF
// module chunks = 1